import {
  mergeStyles,
  uiblockerStyle,
  getColumnSolidBorderStyle,
  messageBarStyle,
  advancedSettingsSectionStyle,
  tableStyle,
  targetLocationRecommendationStyle,
  toggleButtonStyle,
  statusStyle,
  entitySelectorStyle,
  InlineEditorStyle,
  paginationStyle,
} from '@bingads-webui-campaign-react/common-styles';
import { pagePaddingStyle } from '@bingads-webui-campaign-react/page-padding-style';
import { inlineChartContainerStyle } from '@bingads-webui-campaign-react/inline-chart-style';
import { cashbackPercentGridCommonStyle } from '@bingads-webui-campaign/personalized-offer-columns';

function globalAdapter(theme, ...styles) {
  return {
    div: {
      ...mergeStyles(theme, ...styles),
    },
  };
}

// For circular dependency, we cannot import creationCommonStyle directly
// Use IoC, to inject the creationCommonStyle
// TODO: The level of common-settings-page-style.js is not the same as the others in the common-styles
export const getCommonSettingsPageStyles = (formEditorStyles, ...moreStyles) => (_, theme) => {
  const { palette } = theme;
  return {
    inlineChartContainer: inlineChartContainerStyle(palette),
    topGridPanelCustomStyles: {
      '@global': {
        ...mergeStyles(
          { theme },
          {
            '.settings-top-grid-panel-container': {
              '@global': {
                ...mergeStyles(
                  { theme },
                  formEditorStyles(theme),
                  {
                    div: { // this div is to add the priority for this override styles
                      '& .alert': {
                        // override the behavior
                        display: 'block',
                        padding: '8px 32px 20px 8px',
                      },
                      '& .ima-reach-alert': {
                        padding: '8px 32px 8px 8px !important',
                      },
                      '& .alert.alert-recommendation': {
                        background: '#EFF6FC',
                        border: '1px solid #0078D4 !important',
                        padding: '10px 32px 10px 8px !important',
                        lineHeight: '16px !important',
                        fontWeight: 600,
                        '& .alert-info-inline': {
                          marginLeft: '12px',
                        },
                        '& .recommendation-light-bulb': {
                          color: '#0078D4',
                          overflow: 'visible',
                          background: '#EFF6FC',
                          marginRight: '2px',
                          paddingRight: '0px !important',
                          '&:before': {
                            content: "'\\EA80'",
                            lineHeight: '22px',
                            fontFamily: 'MsAds MDL2 Assets',
                            fontSize: '16px',
                          },
                        },
                      },
                      '& .alert-image': {
                        float: 'left',
                      },
                      '& .alert-info-inline': {
                        marginLeft: '24px',
                      },
                      '& .HelpTopic': {
                        marginLeft: '4px',
                      },
                      '& .toggle-campaign-settings-switch': {
                        paddingRight: '8px !important',
                        marginTop: 3,
                        display: 'inline-block',
                        float: 'left',
                      },
                      '& .col-sm-10, .col-sm-2, .col-sm-4': {
                        paddingLeft: '0',
                      },
                      '& .control-label': {
                        marginTop: '0px',
                      },
                      '& .ba-campaign-selector, .ba-campaign-adgroup-selector, .col-sm-10 .control-label': {
                        marginTop: '8px !important',
                        marginBottom: '8px !important',
                      },
                      '& .alert.alert-info.form-group': {
                        marginBottom: '33px',
                      },
                      '& table': {
                        marginTop: '8px',
                      },
                      '& p': {
                        display: 'flex',
                      },
                      '& .form-group[data-property="BidMultiplier"]': {
                        padding: '8px 0px',
                      },
                      // campaign selector style is influenced by .settings-top-grid-panel-container ol
                      // only campaign selector is influenced as it use ul element for dropdown menu
                      '& .ba-campaign-selector .dropdown-menu': {
                        paddingLeft: '8px !important',
                      },
                    },
                  }
                ),
              },
            },
          },
          messageBarStyle,
          {
            '.settings-top-grid-panel-container': {
              borderTop: 'unset !important',
              '& .radio-with-icon': {
                paddingTop: '12px',
                paddingBottom: '5px',
                '& label, .helpbutton': {
                  display: 'inline',
                },
              },
            },
          },
          ...moreStyles // by pass the styles to the mergeStyles function
        ),
      },
      ...mergeStyles(
        { theme },
        tableStyle,
        advancedSettingsSectionStyle,
        toggleButtonStyle,
        paginationStyle
      ),
    },
    '@global': {
      '.smart-shopping-campaign-settings-grid #bulk-edit-bid-multiplier[disabled]': {
        display: 'none',
      },
      '.locations-table, .ad-schedule-table, .devices-table': {
        '& .bingadsgrid': {
          ...getColumnSolidBorderStyle(1, 2),
        },
      },
      '.excluded-locations-view': {
        ...getColumnSolidBorderStyle(1, 2),
      },
      '.devices-page': {
        '& .bid-adjustment-disclaimer': {
          marginTop: '12px',
        },
      },
      ...cashbackPercentGridCommonStyle({ palette }),
      // FIXME: since now paginationStyle, statusStyle and entitySelectorStyle are not global, we need
      // this work around to make jss happy.
      ...globalAdapter(
        { theme },
        statusStyle,
        entitySelectorStyle
      ),
      ...pagePaddingStyle(),
      ...targetLocationRecommendationStyle(theme),
      ...uiblockerStyle({ palette }),
      ...InlineEditorStyle(),
    },
  };
};

